import {
    Box,
    FormControl,
    FormErrorMessage,
    FormLabel,
    Icons,
    Input,
    ThemeColorVariable,
    ThemeSpaceVariable,
} from "@caspeco/casper-ui-library";
import { useExternalBookingSettings } from "api/api-hooks/use-external-booking-settings";
import BookingRequestContinueButton from "components/booking-request/booking-request-continue-button";
import SelectionHeader from "components/selection-components/selection-header";
import { useBookingActionsContext } from "hooks/use-booking-state";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface GuestFormData {
    guests: number;
}

export function SelectRequestGuests() {
    const { t } = useTranslation();
    const { setGuests } = useBookingActionsContext();
    const { data: settings } = useExternalBookingSettings();

    const maxWebGuests = settings?.unitsMetaData?.maxWebGuests ?? 0;

    const {
        register,
        handleSubmit,
        formState: { errors, isValid },
    } = useForm<GuestFormData>({
        mode: "onTouched",
        defaultValues: {
            guests: undefined,
        },
    });

    const onSubmit = (data: GuestFormData) => {
        setGuests?.(data.guests);
    };

    const handleContinue = () => {
        if (!isValid) return;
        void handleSubmit(onSubmit)();
    };

    const handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        void handleSubmit(onSubmit)();
    };

    const minGuests = maxWebGuests + 1;
    return (
        <form onSubmit={handleFormSubmit}>
            <FormControl>
                <SelectionHeader text={t("bookingRequest.guests.title")} icon={Icons.UserGroup} />
                <Box mb={ThemeSpaceVariable.Large}>
                    <FormControl isInvalid={!!errors.guests}>
                        <FormLabel mb={ThemeSpaceVariable.XSmall}>
                            {t("bookingRequest.guests.label")}
                            <Box
                                as="span"
                                color={ThemeColorVariable.Error}
                                ml={ThemeSpaceVariable.XSmall}
                            >
                                *
                            </Box>
                        </FormLabel>
                        <Input
                            type="number"
                            min="1"
                            size="lg"
                            {...register("guests", {
                                required: {
                                    value: true,
                                    message: t("bookingRequest.validation.guestsRequired"),
                                },
                                min: {
                                    value: minGuests,
                                    message: t("bookingRequest.validation.guestsMinimum", {
                                        min: minGuests,
                                    }),
                                },
                                valueAsNumber: true,
                            })}
                        />
                        <FormErrorMessage>{errors.guests?.message}</FormErrorMessage>
                    </FormControl>
                </Box>
                <BookingRequestContinueButton handleContinue={handleContinue} disabled={!isValid} />
            </FormControl>
        </form>
    );
}
